import { AnchorageDigitalLogo } from '@latitude/icons';
import { Text } from '@latitude/text';
import MobileNotSupportedIllustration from 'illustrations/MobileNotSupported';

const MOBILE_NOT_SUPPORTED_TITLE =
  'Access to this form is available only on desktop browsers';
const MOBILE_NOT_SUPPORTED_BODY = 'To continue, please use a desktop computer';

// Full-screen message shown instead of a form when the viewport is too
// narrow. Figma: ADX-onboarding-applications, node 13878:53007.
export const MobileNotSupported = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div
      data-testid="mobile-not-supported"
      className="flex min-h-screen w-full flex-col items-center gap-10 px-4 py-10"
    >
      <AnchorageDigitalLogo className="h-12 w-auto shrink-0 self-start text-color-ref-text-strong" />
      <div className="flex w-full max-w-[343px] flex-1 flex-col items-center justify-center gap-6">
        <MobileNotSupportedIllustration className="w-full shrink-0" />
        <Text
          asChild
          variant="headingLarge"
          color="strong"
          className="text-center"
        >
          <h1>{MOBILE_NOT_SUPPORTED_TITLE}</h1>
        </Text>
        <Text
          asChild
          variant="headingTiny"
          color="strong"
          className="text-center"
        >
          <p>{MOBILE_NOT_SUPPORTED_BODY}</p>
        </Text>
      </div>
      <Text variant="bodyMedium" color="muted" className="text-center">
        © {currentYear} Anchorage Digital
      </Text>
    </div>
  );
};
